import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const RequestEmailChangeRequestDtoSchema = z.object({
  newEmail: z.email(),
});

const RequestEmailChangeResponseDtoSchema = z.object();

export type RequestEmailChangeRequestDto = z.infer<
  typeof RequestEmailChangeRequestDtoSchema
>;
export type RequestEmailChangeResponseDto = z.infer<
  typeof RequestEmailChangeResponseDtoSchema
>;

export const requestEmailChange = (
  dto: RequestEmailChangeRequestDto,
  config?: AxiosRequestConfig<RequestEmailChangeRequestDto>
) => {
  const data = RequestEmailChangeRequestDtoSchema.parse(dto);
  return api
    .post('/users/account/request-email-change', data, config)
    .then(responseContract(RequestEmailChangeResponseDtoSchema));
};
